import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withId = /*#__PURE__*/_withScopeId("data-v-21b11dba");

_pushScopeId("data-v-21b11dba");

var _hoisted_1 = {
  class: "newsTop"
};
var _hoisted_2 = {
  class: "columns padding-top50 padding-bottom50"
};
var _hoisted_3 = {
  class: "box grey"
};
var _hoisted_4 = {
  class: "text-bold padding-bottom20"
};
var _hoisted_5 = {
  key: 0,
  class: "new"
};

_popScopeId();

export var render = /*#__PURE__*/_withId(function (_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createBlock("div", _hoisted_1, [_createVNode("div", _hoisted_2, [(_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.data, function (n) {
    return _openBlock(), _createBlock("div", {
      key: n.id,
      class: "column col-4"
    }, [_createVNode("div", _hoisted_3, [_createVNode("div", _hoisted_4, [_createTextVNode(_toDisplayString(n.title) + " ", 1), n.new ? (_openBlock(), _createBlock("span", _hoisted_5, "NOVO")) : _createCommentVNode("", true)]), _createVNode("div", {
      innerHTML: n.text
    }, null, 8, ["innerHTML"])])]);
  }), 128))])]);
});